import React from "react";

export const aud = (v, dp = 0) =>
  v === null || v === undefined ? "—" : `$${Number(v).toLocaleString("en-AU", { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
export const num = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("en-AU"));
export const pct = (v) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${v}%`);

export const SYSTEMS = [
  "Electrical", "Batteries & charging", "Solar", "Inverter", "Water pump & plumbing", "Water tank sensors", "Air conditioning",
  "Refrigeration", "Appliances", "Awning", "Furniture & cabinetry", "Doors, windows & seals", "Chassis & suspension",
  "Body & exterior", "Manufacturing & assembly", "Other",
];
export const LINE_TYPES = {
  labour_only: "Labour only", supply_and_install: "Supply & install", parts_only: "Parts only", diagnostic: "Diagnostic",
  materials: "Materials", freight_callout: "Freight / call-out", sundry: "Sundries", other: "Other",
};

export function Card({ title, icon: Icon, actions, children, className = "", testId }) {
  return (
    <section className={`bg-[#0F0F0F]/90 border border-neutral-800 rounded-2xl p-5 ${className}`} data-testid={testId}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 mb-4">
          <h2 className="font-heading font-semibold text-white flex items-center gap-2 text-base">
            {Icon && <Icon size={18} className="text-[#73bf44]" weight="duotone" />} {title}
          </h2>
          <div className="flex items-center gap-2">{actions}</div>
        </div>
      )}
      {children}
    </section>
  );
}

export function Stat({ label, value, sub, tone = "white", testId }) {
  const color = { white: "text-white", green: "text-[#73bf44]", gold: "text-[#d9b45b]", amber: "text-amber-400", red: "text-red-400" }[tone];
  return (
    <div className="bg-black/30 border border-neutral-800 rounded-xl px-4 py-3" data-testid={testId}>
      <div className="text-[0.62rem] uppercase tracking-[0.16em] font-bold text-neutral-500">{label}</div>
      <div className={`font-heading text-2xl font-bold tabular-nums mt-1 ${color}`}>{value}</div>
      {sub && <div className="text-[0.7rem] text-neutral-500 mt-0.5">{sub}</div>}
    </div>
  );
}

export function Pill({ children, tone = "neutral", testId }) {
  const cls = {
    neutral: "text-neutral-300 bg-white/[0.04] border-neutral-700", green: "text-[#73bf44] bg-[#73bf44]/10 border-[#73bf44]/30",
    amber: "text-amber-400 bg-amber-500/10 border-amber-500/30", red: "text-red-400 bg-red-500/10 border-red-500/30",
    sky: "text-sky-300 bg-sky-500/10 border-sky-500/30",
  }[tone];
  return <span className={`inline-flex items-center gap-1 text-[0.65rem] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${cls}`} data-testid={testId}>{children}</span>;
}

export const selectCls = "bg-black/50 border border-neutral-800 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#73bf44] transition-colors";
export const btnPrimary = "inline-flex items-center gap-2 bg-[#73bf44] text-[#050505] rounded-full font-heading font-bold px-4 py-2 text-sm hover:bg-[#5fa338] transition-colors disabled:opacity-40";
export const btnGhost = "inline-flex items-center gap-2 border border-neutral-700 text-neutral-200 rounded-full px-4 py-2 text-sm hover:border-[#73bf44] hover:text-white transition-colors disabled:opacity-40";

export function Empty({ children }) {
  return <div className="text-sm text-neutral-500 py-8 text-center">{children}</div>;
}
